import _slicedToArray from "/codebuild/output/src3434728972/src/landings/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _construct from "/codebuild/output/src3434728972/src/landings/node_modules/@babel/runtime/helpers/esm/construct.js";
import _toConsumableArray from "/codebuild/output/src3434728972/src/landings/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
function getEncodedValue(input, allowEmptyString) {
  if (input == null) {
    return input;
  }
  if (input.length === 0 && (!allowEmptyString || allowEmptyString && input !== "")) {
    return null;
  }
  var str = input instanceof Array ? input[0] : input;
  if (str == null) {
    return str;
  }
  if (!allowEmptyString && str === "") {
    return null;
  }
  return str;
}
function getEncodedValueArray(input) {
  if (input == null) {
    return input;
  }
  return input instanceof Array ? input : input === "" ? [] : [input];
}
function encodeDate(date) {
  if (date == null) {
    return date;
  }
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  return "".concat(year, "-").concat(month < 10 ? "0".concat(month) : month, "-").concat(day < 10 ? "0".concat(day) : day);
}
function decodeDate(input) {
  var dateString = getEncodedValue(input);
  if (dateString == null) return dateString;
  var parts = dateString.split("-");
  if (parts[1] != null) {
    parts[1] -= 1;
  } else {
    parts[1] = 0;
    parts[2] = 1;
  }
  var decoded = _construct(Date, _toConsumableArray(parts));
  if (isNaN(decoded.getTime())) {
    return null;
  }
  return decoded;
}
function encodeDateTime(date) {
  if (date == null) {
    return date;
  }
  return date.toISOString();
}
function decodeDateTime(input) {
  var dateString = getEncodedValue(input);
  if (dateString == null) return dateString;
  var decoded = new Date(dateString);
  if (isNaN(decoded.getTime())) {
    return null;
  }
  return decoded;
}
function encodeBoolean(bool) {
  if (bool == null) {
    return bool;
  }
  return bool ? "1" : "0";
}
function decodeBoolean(input) {
  var boolStr = getEncodedValue(input);
  if (boolStr == null) return boolStr;
  if (boolStr === "1") {
    return true;
  } else if (boolStr === "0") {
    return false;
  }
  return null;
}
function encodeNumber(num) {
  if (num == null) {
    return num;
  }
  return String(num);
}
function decodeNumber(input) {
  var numStr = getEncodedValue(input);
  if (numStr == null) return numStr;
  if (numStr === "") return null;
  var result = +numStr;
  return result;
}
function encodeString(str) {
  if (str == null) {
    return str;
  }
  return String(str);
}
function decodeString(input) {
  var str = getEncodedValue(input, true);
  if (str == null) return str;
  return String(str);
}
function decodeEnum(input, enumValues) {
  var str = decodeString(input);
  if (str == null) return str;
  return enumValues.includes(str) ? str : void 0;
}
function decodeArrayEnum(input, enumValues) {
  var arr = decodeArray(input);
  if (arr == null) return arr;
  if (!arr.length) return void 0;
  return arr.every(function (str) {
    return str != null && enumValues.includes(str);
  }) ? arr : void 0;
}
function decodeDelimitedArrayEnum(input, enumValues) {
  var entrySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "_";
  if (input != null && Array.isArray(input) && !input.length) return void 0;
  var arr = decodeDelimitedArray(input, entrySeparator);
  return decodeArrayEnum(arr, enumValues);
}
function encodeJson(any) {
  if (any == null) {
    return any;
  }
  return JSON.stringify(any);
}
function decodeJson(input) {
  var jsonStr = getEncodedValue(input);
  if (jsonStr == null) return jsonStr;
  var result = null;
  try {
    result = JSON.parse(jsonStr);
  } catch (e) {}
  return result;
}
function encodeArray(array) {
  if (array == null) {
    return array;
  }
  return array;
}
function decodeArray(input) {
  var arr = getEncodedValueArray(input);
  if (arr == null) return arr;
  return arr;
}
function encodeNumericArray(array) {
  if (array == null) {
    return array;
  }
  return array.map(String);
}
function decodeNumericArray(input) {
  var arr = decodeArray(input);
  if (arr == null) return arr;
  return arr.map(function (d) {
    return d === "" || d == null ? null : +d;
  });
}
function encodeDelimitedArray(array) {
  var entrySeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_";
  if (array == null) {
    return array;
  }
  return array.join(entrySeparator);
}
function decodeDelimitedArray(input) {
  var entrySeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_";
  var arrayStr = getEncodedValue(input, true);
  if (arrayStr == null) return arrayStr;
  if (arrayStr === "") return [];
  return arrayStr.split(entrySeparator);
}
var encodeDelimitedNumericArray = encodeDelimitedArray;
function decodeDelimitedNumericArray(arrayStr) {
  var entrySeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_";
  var decoded = decodeDelimitedArray(arrayStr, entrySeparator);
  if (decoded == null) return decoded;
  return decoded.map(function (d) {
    return d === "" || d == null ? null : +d;
  });
}
function encodeObject(obj) {
  var keyValSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
  var entrySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "_";
  if (obj == null) return obj;
  if (!Object.keys(obj).length) return "";
  return Object.keys(obj).map(function (key) {
    return "".concat(key).concat(keyValSeparator).concat(obj[key]);
  }).join(entrySeparator);
}
function decodeObject(input) {
  var keyValSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
  var entrySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "_";
  var objStr = getEncodedValue(input, true);
  if (objStr == null) return objStr;
  if (objStr === "") return {};
  var obj = {};
  var keyValSeparatorRegExp = new RegExp("".concat(keyValSeparator, "(.*)"));
  objStr.split(entrySeparator).forEach(function (entryStr) {
    var _entryStr$split = entryStr.split(keyValSeparatorRegExp),
      _entryStr$split2 = _slicedToArray(_entryStr$split, 2),
      key = _entryStr$split2[0],
      value = _entryStr$split2[1];
    obj[key] = value;
  });
  return obj;
}
var encodeNumericObject = encodeObject;
function decodeNumericObject(input) {
  var keyValSeparator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
  var entrySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "_";
  var decoded = decodeObject(input, keyValSeparator, entrySeparator);
  if (decoded == null) return decoded;
  var decodedNumberObj = {};
  for (var _i = 0, _Object$keys = Object.keys(decoded); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    decodedNumberObj[key] = decodeNumber(decoded[key]);
  }
  return decodedNumberObj;
}
export { decodeArray, decodeArrayEnum, decodeBoolean, decodeDate, decodeDateTime, decodeDelimitedArray, decodeDelimitedArrayEnum, decodeDelimitedNumericArray, decodeEnum, decodeJson, decodeNumber, decodeNumericArray, decodeNumericObject, decodeObject, decodeString, encodeArray, encodeBoolean, encodeDate, encodeDateTime, encodeDelimitedArray, encodeDelimitedNumericArray, encodeJson, encodeNumber, encodeNumericArray, encodeNumericObject, encodeObject, encodeString };